import styled from "styled-components";

export const MyTextArea = styled.textarea`
  width: 100%;
  border: 1px solid #9d9d9d;
  resize: none;
  outline: none;
  padding: 10px;
  height: 100%;
  border-radius: 10px;

  font-family: Mulish;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;
